import { FC, ReactNode } from 'react';
import { isUndefined } from '@libs/shared';
import { Check, QuestionCircleFilled, Tooltip } from '@fx-ui/fine-design';
import { platformIntl } from '../../../../constants';

interface OpCheckProps {
    loading?: boolean;
    readable?: boolean;
    writable?: boolean;
    tooltip?: ReactNode;
    children?: React.ReactNode;
    onReadableChange?: (checked: boolean) => void;
    onWritableChange?: (checked: boolean) => void;
}

const OpCheck: FC<OpCheckProps> = ({
    loading = false,
    readable,
    writable = false,
    tooltip = false,
    children,
    onReadableChange,
    onWritableChange
}) => {
    return (
        <div className="fx-op-check">
            <div className="op-wrapper">
                {isUndefined(readable) ? (
                    <Check
                        className="op-readable-and-writable"
                        hasPadding={false}
                        checked={writable}
                        disabled={loading}
                        onChange={() => onWritableChange?.(!writable)}
                    >
                        {platformIntl.get('fxp.base.bg.admin.can_view_manage.opt')}
                        {tooltip && (
                            <Tooltip
                                style={{ width: 200 }}
                                placement="top"
                                effect="light"
                                content={tooltip}
                            >
                                <QuestionCircleFilled className="tip-icon" />
                            </Tooltip>
                        )}
                    </Check>
                ) : (
                    <>
                        <Check
                            className="op-readable"
                            hasPadding={false}
                            disabled={loading}
                            checked={readable}
                            onChange={() => onReadableChange?.(!readable)}
                        >
                            {platformIntl.get('fxp.base.bg.admin.visible.opt')}
                        </Check>
                        <Check
                            className="op-writable"
                            hasPadding={false}
                            disabled={loading}
                            checked={writable}
                            onChange={() => onWritableChange?.(!writable)}
                        >
                            {platformIntl.get('fxp.base.bg.admin.manageable.opt')}
                        </Check>
                    </>
                )}
            </div>
            {(readable || writable) && children}
        </div>
    );
};

export default OpCheck;
